/* eslint-disable max-lines */
import WarningMsg from 'components/WarningMsg';
import React from 'react';
import {
  getActiveLanguageMatcher,
  getActiveLanguageMatcherId,
  saveIdentifierRequestLoading,
  unsavedChanges,
} from 'selectors/identifier';
import { useSelector } from 'store';
import { languageMatcherNotificationMsgs } from 'utils/userNotificationMsgs';
import AddLanguageMatcherInput from '../AddLanguageMatcherInput';
import DeleteMatcherButton from '../DeleteMatcherButton';
import LanguageMatcherHeader from '../LanguageMatcherHeader';

type Props = { isSaved: boolean };

const RawRegexForm: React.FC<Props> = ({ isSaved }) => {
  const unsaved = useSelector(unsavedChanges);
  const isLoadingSaveIdentifier = useSelector(saveIdentifierRequestLoading);
  const activeLanguageMatcher = useSelector(getActiveLanguageMatcher);
  const activeLanguageMatcherId = useSelector(getActiveLanguageMatcherId);

  return (
    <div className="flex flex-col pt-5 pl-10 pr-4 pb-6 text-body h-full">
      <div className="flex flex-row justify-end">
        <WarningMsg
          message={languageMatcherNotificationMsgs.unsavedChanges}
          showLoading={isLoadingSaveIdentifier}
          showWarning={unsaved}
          showSavedMsg={isSaved}
        />
      </div>

      <div className="-mt-4 flex flex-col gap-4 text-body h-full">
        <LanguageMatcherHeader showTypeSelector={false} />

        <div className="mt-10 flex flex-col gap-4">
          <div className="w-124">
            <AddLanguageMatcherInput
              languageMatcherId={activeLanguageMatcherId}
              type="raw_regex"
              form="patterns"
            />
          </div>

          <div className="w-124 pt-4">
            <AddLanguageMatcherInput
              languageMatcherId={activeLanguageMatcherId}
              type="raw_regex"
              form="flags"
            />
          </div>
        </div>

        <div className="mt-auto pt-6 flex flex-row justify-end items-center">
          <DeleteMatcherButton
            text="Delete Matcher"
            setValue={(): void => {
              // moot
            }}
            setHighlightedLanguageMatcher={(): void => {
              // moot
            }}
            activeLanguageMatcher={activeLanguageMatcher}
          />
        </div>
      </div>
    </div>
  );
};

export default RawRegexForm;
